import { HistoryEvent } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

class PartnerSetupPausedActionParser {
  check(event: HistoryEvent): boolean {
    return nameStartsWith(event, 'dashboard:mobile_app:partner_module_paused');
  }

  getAction(): string {
    return 'paused';
  }
}

export const partnerSetupPausedActionParser = new PartnerSetupPausedActionParser();
